import React, { useEffect, useState } from 'react'
import TestimonialBg from "../../../assets/images/testimonial-bg.jpg"
import Shape5 from "../../../assets/images/shape-5.png"
import User1 from "../../../assets/images/testimonial-1.jpg"
import User2 from "../../../assets/images/testimonial-2.jpg"
import Slider from 'react-slick'
import { axiosInstance, config } from '../config'
import Loader from "../../common/Loader";

const Testimonials = () => {

    const settings = {
        dots: false,
        fade: false,
        infinite: false,
        speed: 3000,
        slidesToShow: 2,
        slidesToScroll: 1,
        waitForAnimate: false,
        arrows: false,
        autoplay: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };

    const [Loading, setLoading] = useState(false);
    const [Reviews, setReviews] = useState([]);

    useEffect(() => {
        getReviews()
    }, [])

    function getReviews() {
        setLoading(true)
        axiosInstance.get(`/get-reviews`)
            .then(res => {
                setReviews(res?.data?.reviews?.filter(item => Number(item.status) === 0).reverse())
            })
            .catch((err) => console.log(err))
            .finally(() => {
                setLoading(false)
            })
    }

    return (
        <div>
            {Loading && <Loader />}
            <section className="testimonial-section">
                <div className="bg-layer" style={{ backgroundImage: `url(${TestimonialBg})` }}></div>
                <div className="pattern-layer float-bob-x" style={{ backgroundImage: `url(${Shape5})` }}></div>
                <div className="auto-container">
                    <div className="row clearfix">
                        <div className="col-lg-4 col-md-12 col-sm-12 title-column">
                            <div className="title-inner">
                                <div className="sec-title light">
                                    <h2>Reviews &amp; Testimonials</h2>
                                    <p>At Precision Driving, we take great pride in delivering exceptional service and outstanding experiences to our customers. But don’t just take our word for it—hear directly from our satisfied clients!</p>
                                </div>
                                <div className="rating-box">
                                    <h4>Excellent</h4>
                                    <ul className="rating clearfix">
                                        <li><i className="bi bi-star-fill"></i></li>
                                        <li><i className="bi bi-star-fill"></i></li>
                                        <li><i className="bi bi-star-fill"></i></li>
                                        <li><i className="bi bi-star-fill"></i></li>
                                        <li><i className="bi bi-star-half"></i></li>
                                    </ul>
                                </div>
                                {/* <div className="review-box">
                                    <p>Trust Score 4.5 (Based on 2,500 reviews)</p>
                                </div> */}
                            </div>
                        </div>
                        <div className="col-lg-8 col-md-12 col-sm-12 testimonial-column">
                            <div className="testimonial-content">
                                <div className="row clearfix">
                                    <Slider {...settings} >
                                        {Reviews.length > 0 && Reviews.map((item, i) => (
                                            <div className="col-lg-6 col-md-6 col-sm-12 testimonial-block">
                                                <div className="testimonil-block-one">
                                                    <div className="inner-box mx-3">
                                                        <div className="border-box"></div>
                                                        <div className="bg-shape"></div>
                                                        <ul className="rating clearfix">
                                                            {Array(5)
                                                                .fill(0)
                                                                .map((_, index) => (
                                                                    <li key={index}>
                                                                        {index < item.rating ? (
                                                                            <i className="bi bi-star-fill"></i> // Filled star
                                                                        ) : (
                                                                            <i className="bi bi-star"></i> // Empty star
                                                                        )}
                                                                    </li>
                                                                ))}
                                                        </ul>
                                                        <h4>{item?.title}</h4>
                                                        <p>{item.description}</p>
                                                        <div className="author-box">
                                                            <figure className="author-thumb"><img src={item?.user?.image ? `${config.imageUrl}${item?.user?.image}` : User1} alt="" /></figure>
                                                            <h4 className='h-100 d-flex align-items-center'>{item?.user?.name}</h4>
                                                            {/* <h6>{item?.user?.address}</h6> */}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </Slider>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Testimonials
